import { render, staticRenderFns } from "./dataInfo.vue?vue&type=template&id=6e81ffce&scoped=true&"
import script from "./dataInfo.vue?vue&type=script&lang=js&"
export * from "./dataInfo.vue?vue&type=script&lang=js&"
import style0 from "./dataInfo.vue?vue&type=style&index=0&id=6e81ffce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e81ffce",
  null
  
)

export default component.exports